{
  "home": {
    "menu": {
      "title": "Басты бет"
    },
    "page": {
      "title": "Басты бет"
    },
    "search": {
      "placeholder": "Іздеу"
    },
    "map": {
      "label": "Белсенділік картасы",
      "loading": "Карта жүктелуде…",
      "error": "Карта деректерін жүктеу мүмкін болмады.",
      "empty": "Бұл кезеңде дерек жоқ.",
      "emptyAssets": "Бұл кезеңде активтер жоқ.",
      "emptyActivity": "Бұл кезеңде белсенділік жоқ.",
      "emptyRoutines": "Бұл кезеңде рутін белсенділігі жоқ.",
      "emptyProducts": "Бұл кезеңде өнімдер жоқ.",
      "noResults": "Бұл сұраныс бойынша нәтиже жоқ."
    },
    "activity": {
      "title": "Белсенділік",
      "total": "Барлығы {{count}}",
      "viewAll": "Барлығын көру",
      "solved": "Шешілді",
      "pending": "Күтуде",
      "urgent": "Шұғыл",
      "error": "Белсенділік деректерін жүктеу мүмкін болмады",
      "empty": "Бұл кезеңде белсенділік жоқ",
      "plot": "Белсенділікті картада көрсету"
    },
    "cards": {
      "viewAll": "Барлығын көру",
      "error": "Деректерді жүктеу мүмкін болмады"
    },
    "assets": {
      "title": "Активтер",
      "empty": "Бұл кезеңде активтер жоқ",
      "plot": "Активтерді картада көрсету",
      "filterBy": "Картаны {{status}} бойынша сүзу"
    },
    "routines": {
      "title": "Рутіндер",
      "empty": "Рутіндер жоқ",
      "plot": "Рутін орындарын картада көрсету",
      "filterBy": "{{name}} картада көрсету"
    },
    "products": {
      "title": "Өнімдер",
      "empty": "Өнімдер жоқ",
      "plot": "Өнімдерді картада көрсету",
      "filterBy": "{{name}} картада көрсету"
    },
    "campaigns": {
      "title": "Науқандар",
      "empty": "Науқандар жоқ"
    },
    "customers": {
      "title": "Тұтынушылар",
      "empty": "Тұтынушылар жоқ",
      "sample": "Үлгі деректері",
      "active": "Белсенді",
      "pending": "Күтуде",
      "new": "Жаңа"
    },
    "plot": {
      "activity": "Белсенділік көрсетілуде",
      "asset": "Активтер көрсетілуде",
      "routine": "Рутін орындары көрсетілуде",
      "product": "Өнімдер көрсетілуде"
    },
    "timeRange": {
      "label": "Уақыт аралығы",
      "today": {
        "label": "Бүгін",
        "a11y": "Бүгін"
      },
      "7d": {
        "label": "7D",
        "a11y": "Соңғы 7 күн"
      },
      "30d": {
        "label": "30D",
        "a11y": "Соңғы 30 күн"
      },
      "90d": {
        "label": "90D",
        "a11y": "Соңғы 90 күн"
      },
      "1y": {
        "label": "1Y",
        "a11y": "Соңғы жыл"
      },
      "all": {
        "label": "Барлығы",
        "a11y": "Барлық уақыт"
      }
    }
  },
  "accountPage": {
    "header": {
      "accountTypes": "Аккаунт түрлері",
      "newUsersSetup": "Жаңа пайдаланушылар қосылады"
    },
    "types": {
      "general": "Жалпы",
      "admin": "Әкімші",
      "restricted": "Шектеулі",
      "anonymous": "Анонимді"
    },
    "table": {
      "headers": {
        "accountType": "Аккаунт түрі",
        "accessActivity": "Белсенділікке қол жеткізу?",
        "accessSettings": "Баптауларға қол жеткізу?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Бөлінген активтер мен топтарға шектеулі",
        "generalToSettingsNote": "Активтер мен адамдарға шектеулі"
      }
    },
    "info": {
      "header": "Аккаунт түрлерінің түсіндірмесі",
      "admin": "Жұмыс орны иелері, аға менеджерлер және кеңсе әкімшілері үшін идеалды.",
      "general": "Толық уақыттық қызметкерлер мен қызметкерлер үшін идеалды. (Біздің ұсынылған әдепкі.)",
      "restricted": "Белгілі қонақтар, жеткізушілер, жартылай уақыттық жұмысшылар және жартылай немесе шектеулі қол жеткізу қажет подрядчитер үшін идеалды.",
      "anonymous": "Gripp-ке тіркелмеген адамдар үшін. Олар тек сканерлеген нәрселерге негізделген Есептер, Ескертпелер немесе Рутіндерді ғана жібере алады."
    },
    "menu": {
      "accountPage": "Аккаунт",
      "settingsPage": "Баптаулар",
      "workspaceSettingsPage": "Жұмыс кеңістігінің баптаулары"
    },
    "workplaceTitle": "Жұмыс орнын басқару және деректер",
    "downloadData": "Деректерді жүктеу",
    "dataExport": {
      "cancel": "Болдырмау",
      "title": "Деректерді экспорттау",
      "download": "Жүктеу"
    }
  },
  "account": {
    "allWorkspaces": "Барлық жұмыс кеңістіктері",
    "create": {
      "button": "Пайдаланушы қосу",
      "form": {
        "email": "Электрондық пошта",
        "firstName": "Аты",
        "lastName": "Тегі",
        "role": "Рөл"
      },
      "validation": {
        "emailRequired": "Электрондық пошта міндетті",
        "role": "Рөл міндетті",
        "validEmail": "Жарамды электрондық пошта мекенжайын енгізіңіз"
      }
    },
    "filter": {
      "apply": "Қолдану",
      "columnSelection": "Бағандар",
      "columns": {
        "createdAt": "Қосылған күні",
        "createdDate": "Қосылған күні",
        "createdTime": "Қосылған уақыты",
        "email": "Электрондық пошта",
        "groups": "Топтар",
        "groupNames": "Топ атаулары",
        "assets": "Активтер",
        "jobTitle": "Лауазым",
        "location": "Орналасқан жері",
        "name": "Аты (міндетті)",
        "phone": "Телефон нөмірі",
        "roles": "Аккаунт түрі",
        "workspace": "Жұмыс кеңістігі"
      },
      "searchPlaceholder": "Аты, нөмірі немесе электрондық поштасы бойынша іздеу",
      "columnButton": "Бағандар",
      "groupsButton": "Топтар",
      "accountTypesButton": "Аккаунт түрлері",
      "noAccountTypes": "Аккаунт түрлері жоқ",
      "groups": "Топтар",
      "accountTypes": "Аккаунт түрлері",
      "default": "Әдепкі",
      "viewResults": "{{count}} нәтижені көру"
    },
    "groups": {
      "addPeopleTo": "{{count}} адамды қосу:",
      "addPersonTo": "1 адамды қосу:"
    },
    "list": {
      "accountType": "Аккаунт түрі",
      "added": "Қосылған күні",
      "createdDate": "Қосылған күні",
      "createdTime": "Қосылған уақыты",
      "email": "Электрондық пошта",
      "groups": "Топтар",
      "assets": "Активтер",
      "jobTitle": "Лауазым",
      "location": "Орналасқан жері",
      "name": "Аты",
      "phone": "Телефон нөмірі",
      "workspace": "Жұмыс кеңістігі"
    },
    "topBar": {
      "peopleSelected": "{{count}} адам таңдалды",
      "personSelected": "1 адам таңдалды"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Иә",
        "secondaryButton": "Болдырмау",
        "title": "Сіз {{accountName}} жойғыңыз келетініне сенімдісіз бе?"
      }
    },
    "detail": {
      "removeAccount": "Тіркелгіні жою"
    }
  },
  "activity": {
    "filter": {
      "cancel": "Болдырмау",
      "groups": "Топтар",
      "activityOptions": "Белсенділік опциялары",
      "activityTypes": "Белсенділік түрлері",
      "options": "Опциялар",
      "types": "Түрлер",
      "notes": "Ескертпелер",
      "note": "Жазба",
      "pending": "Күтуде",
      "reset": "Қалпына келтіру",
      "routines": "Рутіндер",
      "searchPlaceholder": "Белсенділік тақырыптарын немесе актив атауын іздеу",
      "searchLabels": "Белгілерді іздеу",
      "solved": "Шешілді",
      "title": "Сүзгілер",
      "labels": "Белгілер",
      "urgent": "Шұғыл",
      "date": "Күні",
      "all": "Барлығы",
      "day": "күн",
      "week": "апта",
      "month": "ай",
      "today": "Бүгін",
      "thisWeek": "Соңғы 7 күн",
      "thisMonth": "Соңғы 30 күн",
      "custom": "Теңшелетін",
      "customDate": "Теңшелетін күн",
      "from": "Бастап",
      "to": "Дейін",
      "mentions": "Атаулар",
      "scheduled": "Жоспарланған",
      "default": "Әдепкі",
      "notScheduled": "Жоспарланбаған",
      "pinned": "Бекітілген",
      "everything": "Барлығы",
      "onlyMentions": "Тек атаулар",
      "onlyPinned": "Тек бекітілгендер",
      "onlyScheduled": "Тек жоспарланғандар",
      "sort": "Сұрыптау",
      "viewResults": "{{count}} нәтижені көру",
      "combinedGroups": "Біріктірілген сүзгілеу"
    },
    "search": {
      "title": "Іздеу",
      "search": "Іздеу",
      "recentSearches": "Соңғы іздеулер"
    },
    "header": {
      "title": "Белсенділік",
      "view": "Көру",
      "viewAll": "Барлығын көру"
    },
    "list": {
      "youAreMentioned": "Сіз аталдыңыз."
    },
    "menu": {
      "title": "Белсенділік",
      "titlePlural": "Белсенділіктер"
    },
    "textEmpty": "Белсенділік жоқ",
    "topBar": {
      "results": "нәтижелер"
    },
    "sort": {
      "mostRecent": "Соңғы жаңарту",
      "reminderDate": "Еске салғыш күні",
      "oldest": "Жасалған күні"
    },
    "edit": {
      "tab": {
        "activity": "Белсенділік",
        "routine": "Тәртіп"
      }
    },
    "tapScan": "Активтерді немесе шақыру кодтарын сканерлеу үшін \"+\" басыңыз.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Жұмыс кеңістігіне қосылыңыз!",
        "description": "Сіз әлі жұмыс кеңістігінде емессіз.\nЖұмыс кеңістігіне қосылу үшін\nшақыру кодын сканерлеңіз!"
      },
      "addActivity": {
        "title": "Белсенділік қосу",
        "description": "Сізде әлі белсенділік жоқ.\nАктивіңіз туралы есеп немесе ескертпе қосып, командаңызды хабардар ету үшін '+' басыңыз."
      },
      "addAsset": {
        "title": "Активтер қосу",
        "description": "Сізде әлі активтер жоқ.\nБастау үшін '+' басып, бірінші активіңізді сканерлеп қосыңыз."
      },
      "or": "немесе",
      "newSub": "жаңа жазылым бастау",
      "here": "мұнда"
    }
  },
  "admin": {
    "menu": {
      "admin": "Адамдар",
      "workspaces": "Жұмыс кеңістіктері"
    }
  },
  "alerts": {
    "addAnother": "Тағы қосу",
    "create": {
      "alertName": "Ескерту атауы",
      "asset(s)": "Актив(тер)",
      "assetSearchPlaceholder": "Актив атауын іздеу",
      "assets": "Активтер",
      "doNotAlert": "<0>(Міндетті емес)</0><1>Арасында ескертпеу:</1>",
      "groupSearchPlaceholder": "Топ атауын іздеу",
      "groups": "Топтар",
      "promptRoutine": "<0>(Міндетті емес)</0><1>Рутін таңдаңыз</1><0>осы ескертумен сұрау үшін:</0>",
      "promptRoutinePlaceholder": "рутін таңдалмаған",
      "title": "Ескерту құру",
      "what": "1. Не таңдаңыз:",
      "when": "3. Қашан таңдаңыз:",
      "why": "2. Неге таңдаңыз:"
    },
    "setAlert": "Дабыл қосу",
    "setANewAlert": "Жаңа дабыл орнату",
    "createButton": "Жаңасын құру",
    "createNewAlert": "Жаңа ескерту құру",
    "createAlert": "Ескерту құру",
    "alert": "Ескерту",
    "alerts": "Ескертулер",
    "deleteAlert": "Ескертуді жою",
    "nextAlert": "Келесі ескерту: ",
    "lastAlert": "Соңғы ескерту: ",
    "lastAlertNA": "Ж/О",
    "confirm": "Растау",
    "currently": "Қазіргі уақытта: ",
    "abovePlaceholder": "жоғары",
    "belowPlaceholder": "төмен",
    "editAlert": "Ескертуді өңдеу",
    "intervalValue": "Аралық мәні",
    "newAlert": "Жаңа ескерту",
    "number": "Сан",
    "minDropdownPlaceholder": "Ол жоғары болғанда  _____ ",
    "maxDropdownPlaceholder": "Ол төмен болғанда  _____ ",
    "setAlertLogic": "Ескерту логикасын орнату",
    "setAlertLogicPlaceholder": "Ескерту логикасын таңдаңыз",
    "optionalSettings": "Міндетті емес баптаулар",
    "customLabelTitle": "Ескерту тақырыбын теңшеу",
    "blackoutDates": "Блоктау күндері?",
    "startDate": "Басталу күні",
    "starting": "Басталу",
    "day": "күн",
    "days": "күн",
    "togo": "қалды",
    "completions": "аяқталулар",
    "recorded": "жазылды",
    "elapsed": "өтті",
    "OR": "НЕМЕСЕ",
    "or": "немесе",
    "on": "күні",
    "skipped": "өткізілді",
    "every": "әр",
    "Every": "Әр",
    "startingValue": "Бастапқы мән",
    "startingValuePerAsset": "Актив бойынша бастапқы мән",
    "onDate": "Белгілі бір күнде",
    "onDays": "Әр ___ күн",
    "onDayInterval": "Маған ___ кейін еске салу",
    "onDayIntervalUnit": "Аралық",
    "dateInterval": {
      "minutes": "Минуттар",
      "hours": "Сағаттар",
      "days": "Күндер",
      "weeks": "Апталар",
      "months": "Айлар"
    },
    "onDaysSkipped": "Әр ___ күн рутін аяқталмаған",
    "onRoutineCompletions": "Әр ___ рет рутін аяқталған",
    "onInterval": "Аралыққа негізделген",
    "selectRoutineToPrompt": "Сұрау үшін рутін таңдаңыз",
    "selectAlertingLogic": "Ескерту логикасын таңдаңыз",
    "customLabelWhenAlertOccurs": "Ескерту пайда болғанда теңшелетін белгі",
    "selectRoutine": "Рутін таңдаңыз",
    "reset": "Қалпына келтіру",
    "edit": {
      "alertName": "Ескерту атауы",
      "asset(s)": "Актив(тер)",
      "assets": "Активтер",
      "doNotAlert": "Арасында ескертпеу",
      "groups": "Топтар",
      "none": "Жоқ",
      "promptRoutine": "<0>Рутін таңдаңыз</0><1>осы ескертумен сұрау үшін</1>",
      "promptRoutinePlaceholder": "рутін таңдалмаған",
      "setFor": "Бұл ескерту орнатылған",
      "setOn": "Ескертуді орнату",
      "title": "Ескертуді өңдеу",
      "when": "Қашан"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Иә",
        "secondaryButton": "Болдырмау",
        "title": "Сіз {{alertName}} жойғыңыз келетініне сенімдісіз бе?"
      },
      "delete": "Жою",
      "disableAlert": "Ескертуді өшіру",
      "enableAlert": "Ескертуді қосу",
      "viewAlertActivities": "Ескерту белсенділігін көру"
    },
    "new": {
      "header": "Ескертпелер > Ескерту құру"
    },
    "title": "Автоматтандыру",
    "trigger": {
      "counter": {
        "ceiling": "Санағыш жоғарылайды",
        "daysSinceCompleted": "Рутін аяқталмаған",
        "daysSinceCompleted-end": "Күн",
        "every": "Әр",
        "every-end": "Күн",
        "floor": "Санағыш төмендейді",
        "onCompletionCount": "Рутін әр аяқталған",
        "onCompletionCount-end": "Рет",
        "onInterval": "Санағыш аралыққа жетеді"
      },
      "default": {
        "daysSinceCompleted": "Рутін аяқталмаған",
        "daysSinceCompleted-end": "Күн",
        "every": "Әр",
        "every-end": "Күн",
        "onCompletionCount": "Рутін әр аяқталған",
        "onCompletionCount-end": "Рет"
      }
    },
    "validation": {
      "alertTypeRequired": "Ескерту түрі міндетті",
      "inputRequired": "Кіріс міндетті",
      "invalidDate": "Жарамсыз күн",
      "startDateRequiredForDays": "Күн ескерту түрі үшін басталу күні міндетті",
      "routineIdRequiredForInterval": "Аралық үшін рутін id міндетті"
    },
    "setInterval": "Аралықты орнату",
    "numberOfDays": "Күн саны",
    "numberOfTimes": "Рет саны"
  },
  "asset": {
    "advancedAssetInformation": "Активтің кеңейтілген ақпараты",
    "customAlert": {
      "tagAlreadyAdded": "Бұл тег осы активке қосылған.",
      "tryAnotherTag": "Бұл тег қолданыста және таңдауға болмайды, басқа тегті көріңіз."
    },
    "delete": {
      "button": "Активті жою",
      "cancel": "Болдырмау",
      "confirm": "Жою",
      "title": "Сіз бұл активті жойғыңыз келетініне сенімдісіз бе?"
    },
    "description": "Сипаттама",
    "descriptionPlaceholder": "Міндетті емес",
    "details": "Толығырақ",
    "detailsPlaceHolder": "Міндетті емес",
    "editTitle": "Актив ақпараты",
    "groups": "Топтар",
    "groupsPlaceHolder": "(Міндетті емес) Топ(тар) таңдаңыз",
    "groupsSearchPlaceHolder": "Топ атауын іздеу",
    "header": {
      "buttons": {
        "addNew": "Есеп / Ескертпе қосу",
        "routines": "Рутіндер",
        "addSomething": "Бірдеңе қосу"
      },
      "recentActivity": "Соңғы белсенділік",
      "activity": "Белсенділік"
    },
    "information": "Актив ақпараты",
    "mediaLibrary": "Медиа кітапханасы",
    "name": "Атауы",
    "namePlaceholder": "Бұл не?",
    "newIssue": "Жаңа нәрсе?",
    "accessRequest": {
      "requestFull": "Толық қол жеткізуді сұрау",
      "requested": "Қол жеткізу сұралды",
      "modalTitle": "Толық қол жеткізуді сұрау",
      "modalSubtitle": "Жұмыс кеңістігінің иесіне неліктен қол жеткізу қажет екенін білдіру үшін хабарлама қалдырыңыз.",
      "modalPlaceholder": "Қосымша хабарлама...",
      "modalSubmit": "Сұрауды жіберу"
    },
    "newTitle": "Активті орнату",
    "tagCode": "Gripp ID",
    "assetPicture": "Активтің суретін түсіріңіз",
    "newAsset": "Жаңа Актив",
    "assetName": "Атауы",
    "newAdditionalMedia": "Суреттер",
    "secondaryDescription": "Сипаттама",
    "optionalSetting": "Міндетті емес баптаулар",
    "hideReportAndNoteOptionsAnonymous": "Анонимді қонақтар үшін Есеп және Ескертпе опцияларын жасыру",
    "hideReportAndNote": "Есеп & Ескертпе",
    "hideForAnonymousVisitors": "Анонимді қонақтар үшін жасыру",
    "files": {
      "title": "Файлдар",
      "noFiles": "Файлдар табылмады.",
      "addFilesLinks": "Файлдар / сілтемелер қосу",
      "addSheetTitle": "Қосу",
      "addSheetSubtitle": "Файл, медиа немесе сілтеме",
      "uploadFile": "Файлды жүктеу",
      "addLink": "Сілтеме қосу",
      "save": "Сақтау",
      "addFile": "Файлды қосу",
      "view": "{{count}} нәтижені қарау",
      "view_plural": "{{count}} нәтижені қарау",
      "camera": "Камера",
      "file": "Файл",
      "unableToPreview": "Алдын ала қарау мүмкін емес"
    },
    "detail": {
      "edit": "Өңдеу",
      "delete": "Жою",
      "delete_asset": "Активті жою",
      "delete_warning": "Бұл әрекетті болдырмауға болмайды.",
      "confirmDelete": "Сіз {{fileName}} файлын жойғыңыз келетініне сенімдісіз бе?"
    },
    "productType": "Өнім түрі",
    "serialNumber": "Сериялық нөмір",
    "addons": "Қосымшалар ({{count}})",
    "addonsNoProduct": "Бұл активте өнім түрі жоқ. Қосымша таңдауды қосу үшін өнім тағайындаңыз.",
    "enterTagCode": "Тег кодын енгізіңіз",
    "add": "Қосу",
    "cancel": "Болдырмау",
    "save": "Сақтау",
    "tagCodePlaceholder": "Тег кодын енгізіңіз",
    "lookingUpTag": "Тегті іздеу...",
    "pinnedActivity": "Бекітілген белсенділік",
    "viewAll": "Барлығын көру"
  },
  "assets": {
    "filter": {
      "title": "Сүзгілер",
      "search": "Іздеу",
      "recentSearches": "Соңғы іздеулер",
      "apply": "Қолдану",
      "reset": "Қалпына келтіру",
      "viewResults": "{{count}} нәтижені көру",
      "columnButton": "Бағандар",
      "columnSelection": "Бағандар",
      "columns": {
        "createdAt": "Құрылған",
        "createdBy": "Құрушы",
        "description": "Сипаттама",
        "serialNumber": "Сериялық нөмір",
        "productName": "Өнім атауы",
        "groups": "Топтар",
        "groupNames": "Топ атаулары",
        "lastAddress": "Орналасуы",
        "lastScannedAt": "Соңғы сканерлеу",
        "lastUpdated": "Соңғы жаңарту",
        "name": "Атауы (міндетті)",
        "notes": "# ескертпелер",
        "alerts": "# ескертпелер",
        "reports": "# белсенді есептер",
        "routines": "# рутіндер",
        "addons": "# қосымшалар",
        "tagCode": "Gripp ID",
        "workspaces": "Жұмыс кеңістігі"
      },
      "groups": "Топтар",
      "groupsButton": "Топтар",
      "default": "Әдепкі",
      "searchPlaceholder": "Атауы, сипаттамасы, өнімі, add-ons немесе Gripp ID бойынша іздеу",
      "filterToggle": "Біріктірілген сүзгілеу:",
      "combinedGroups": "Біріктірілген сүзгілеу"
    },
    "groups": {
      "addAssetTo": "1 активті қосу:",
      "addAssetsTo": "{{count}} активті қосу:"
    },
    "list": {
      "createdAt": "Құрылған",
      "createdDate": "Құрылған күні",
      "createdTime": "Құрылған уақыты",
      "createdBy": "Құрушы",
      "description": "Сипаттама",
      "serialNumber": "Сериялық нөмір",
      "productName": "Өнім атауы",
      "groups": "Топтар",
      "groupNames": "Топ атаулары",
      "lastAddress": "Орналасуы",
      "lastScannedAt": "Соңғы сканерлеу",
      "lastScannedDate": "Соңғы сканерлеу күні",
      "lastScannedTime": "Соңғы сканерлеу уақыты",
      "lastUpdated": "Соңғы жаңарту",
      "lastUpdatedDate": "Соңғы жаңарту күні",
      "lastUpdatedTime": "Соңғы жаңарту уақыты",
      "name": "Атауы",
      "notes": "Ескертпелер",
      "alerts": "Ескертпелер",
      "reports": "Белсенді есептер",
      "routines": "Рутіндер",
      "addons": "Қосымшалар",
      "tagCode": "Gripp ID",
      "workspaces": "Жұмыс кеңістігі"
    },
    "menu": {
      "title": "Активтер",
      "titleSingular": "Актив"
    },
    "textEmpty": "Активтер жоқ",
    "topBar": {
      "allAssets": "Барлық активтер",
      "assetSelected": "1 актив таңдалды",
      "assetsSelected": "{{count}} актив таңдалды",
      "results": "{{count}} нәтиже"
    },
    "change": "Өзгерту",
    "routines": "Рутіндер",
    "routineSearchPlaceholder": "Рутін атауын іздеу",
    "addonsSearchPlaceholder": "Қосымша атауын іздеу"
  },
  "products": {
    "textEmpty": "Өнімдер жоқ",
    "list": {
      "name": "Атауы"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Профиль"
    }
  },
  "binaryCheck": {
    "button": "Жаңарту",
    "instructions1": "Жаңа жаңарту қолжетімді!",
    "instructions2": "Gripp жаңартуға дейін жұмыс істемейтін болуы мүмкін."
  },
  "camera": {
    "Cancel": "Болдырмау",
    "grippInviteDetected": "Gripp шақыруы анықталды!",
    "grippTagDetected": "Gripp тегі анықталды!",
    "noCameraAccess": "Камераға қол жеткізу жоқ",
    "notGrippInvite": "Gripp шақыруы емес",
    "notGrippTagg": "Gripp тегі емес",
    "tryAgain": "Қайта көріңіз",
    "noPermissionModal": {
      "oopsMessage": "Ой! Сізде осы Gripp тегіне\nқол жеткізу рұқсаты жоқ. 🙈",
      "button": "Түсіндім!",
      "errorMessage": "Егер бұл қате деп ойласаңыз, сіздің\nдұрыс жұмыс орнына шақырылғаныңызды растаңыз немесе\nGripp қолдау қызметіне хабарласыңыз."
    }
  },
  "changesSaved": "Өзгерістер сақталды",
  "common": {
    "back": "Артқа",
    "cancel": "Болдырмау",
    "create": "Жасау",
    "download": "Жүктеу",
    "reset": "Қалпына келтіру",
    "apply": "Қолдану",
    "save": "Сақтау",
    "optional": "Міндетті емес",
    "value": "Мән",
    "delete": "Жою",
    "confirmDelete": "{{name}} жою",
    "deleteWarning": "Бұл әрекетті болдырмауға болмайды.",
    "next": "Келесі",
    "remove": "Жою",
    "typeMessage": "Хабарлама енгізіңіз...",
    "message": "Хабарлама",
    "filter": "Сүзгі",
    "searchOrCreate": "Іздеу немесе жаңасын жасау",
    "groupAssignments": "Топ тағайындаулары"
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Аккаунтты жою",
    "cannotUndone": "Бұл әрекетті болдырмау мүмкін емес.",
    "confirm": "Жоюды растау",
    "header": "Аккаунтты жою",
    "reasonInput": "Аккаунтыңызды жою үшін қосымша мәліметтерді бізге хабарлаңыз (міндетті емес):",
    "reasonInputNoOptional": "Аккаунтыңызды жою үшін қосымша мәліметтерді бізге хабарлаңыз:",
    "submitted": "Аккаунтты жою сұрауыңыз жіберілді."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Қолдану",
      "reset": "Қалпына келтіру"
    }
  },
  "edit": "",
  "email": "Электрондық пошта",
  "features": {
    "title": "Мүмкіндіктер",
    "assignment": {
      "workspaces": "Жұмыс кеңістіктері",
      "accounts": "Аккаунттар",
      "workspaceSearchPlaceholder": "Жұмыс кеңістіктерін іздеу...",
      "accountSearchPlaceholder": "Аккаунттарды іздеу...",
      "noWorkspaces": "Жұмыс кеңістіктері табылмады",
      "noAccounts": "Аккаунттар табылмады",
      "name": "Атауы",
      "email": "Электрондық пошта",
      "phone": "Телефон"
    }
  },
  "campaigns": {
    "menu": {
      "title": "Науқандар"
    },
    "page": {
      "title": "Науқандар"
    },
    "list": {
      "empty": "Ешқандай науқан табылмады",
      "addCampaign": "Науқан жасау"
    },
    "columns": {
      "name": "Аты",
      "status": "Күй",
      "responses": "Жауаптар",
      "groups": "Топтар",
      "products": "Өнімдер",
      "serialNumber": "Сериялық нөмірі",
      "lastUpdated": "Соңғы жаңартылған",
      "createdAt": "Құрылған"
    },
    "create": {
      "panelTitle": "Жаңа науқан"
    },
    "responses": {
      "panelTitle": "Жауаптар"
    },
    "edit": {
      "panelTitle": "Науқанды өңдеу"
    }
  },
  "firstName": "Аты",
  "forbidden": "Тыйым салынған",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Топқа қосу",
      "addtoNewGroup": "Жаңа топқа қосу",
      "apply": "Қолдану",
      "clearGroups": "Топтарды тазалау"
    },
    "searchGroups": "Топтарды іздеу",
    "noGroups": "Топтар жоқ",
    "menu": {
      "title": "Топтар",
      "editGroup": "Топты өңдеу"
    },
    "create": {
      "label": "Жаңа топ құру",
      "validation": {
        "name_required": "Топ атауы міндетті"
      },
      "create": "Құру",
      "placeholder": "мысалы, Тракторлар тобы"
    },
    "list": {
      "name": "Топ атауы",
      "people": "Адамдар",
      "assets": "Активтер",
      "reports": "Белсенді есептер",
      "routines": "Рутіндер",
      "assetAlerts": "Активтер Ескертпелері",
      "groupAlerts": "Топ Ескертпелері"
    },
    "common": {
      "textEmpty": "Топ жоқ",
      "selectGroup": "Топтарды таңдау",
      "searchGroup": "Топтарды іздеу",
      "createGroup": "Топ құру",
      "emptyStateMessage": "Іздеу жолағында тікелей теріп топ құрыңыз."
    },
    "filter": {
      "searchPlaceholder": "Топ атауларын іздеу",
      "columnButton": "Бағандар",
      "columns": {
        "name": "Топ атауы",
        "reports": "Белсенді есептер",
        "assets": "Активтер",
        "people": "Адамдар",
        "routines": "Рутіндер",
        "assetAlerts": "Активтер Ескертпелері",
        "groupAlerts": "Топ Ескертпелері"
      },
      "columnSelection": "Бағандар"
    },
    "assignments": {
      "name": "Аты",
      "jobTitle": "Лауазым",
      "accountType": "Аккаунт түрі",
      "assetSearchPlaceholder": "Актив атауы, сипаттамасы немесе топ атауын іздеу",
      "accountSearchPlaceholder": "Адам аты немесе лауазымын іздеу",
      "routineSearchPlaceholder": "Рутін атауын іздеу",
      "groupSearchPlaceholder": "Топ атауларын іздеу",
      "addonsSearchPlaceholder": "Қосымша атауын іздеу",
      "emptyAccountList": "Аккаунттар жоқ",
      "assets": "Активтер",
      "groups": "Топтар",
      "people": "Адамдар",
      "routines": "Рутіндер"
    },
    "deleteGroup": {
      "deleteGroup": "Топты жою",
      "alertBody1": "Сіз жойғыңыз келетініне сенімдісіз бе",
      "alertBody2": "Ескерту: ",
      "alertBody3": "Бұл осы топпен байланысты активтерді жоймайды ",
      "alertBody4": "топ.",
      "delete": "Жою",
      "cancel": "Болдырмау",
      "toastTitle": "Жойылды!",
      "toastMessage": "{{groupName}} жойылды."
    }
  },
  "help": {
    "menu": {
      "title": "Көмек"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Ескертулер",
      "editAlert": "Ескертуді өңдеу"
    },
    "filter": {
      "searchPlaceholder": "Ескертулерді іздеу...",
      "columnButton": "Бағандар",
      "statusButton": "Мәртебесі",
      "columnSelection": "Бағандарды таңдау",
      "columns": {
        "name": "Атауы",
        "routineName": "Рутина",
        "assetName": "Актив",
        "groupName": "Топ",
        "productName": "Өнім",
        "assetAlerts": "Актив ескертулері",
        "lastAlertDate": "Соңғы ескерту",
        "nextAlertDate": "Келесі ескерту",
        "createdAt": "Жасалды",
        "status": "Мәртебесі"
      },
      "status": {
        "label": "Мәртебесі",
        "all": "Барлығы",
        "enabled": "Қосулы",
        "disabled": "Өшірулі"
      }
    },
    "common": {
      "textEmpty": "Ескертулер табылмады"
    },
    "list": {
      "name": "Атауы",
      "routineName": "Рутина",
      "assetName": "Актив",
      "groupName": "Топ",
      "productName": "Өнім",
      "assetAlerts": "Актив ескертулері",
      "lastAlertDate": "Соңғы ескерту",
      "nextAlertDate": "Келесі ескерту",
      "createdAt": "Жасалды",
      "status": "Мәртебесі"
    },
    "deleteAlert": {
      "deleteAlert": "Ескертуді жою",
      "alertBody1": "Жоюға сенімдісіз бе",
      "alertBody2": "Ескерту:",
      "alertBody3": " Бұл ескертуді жою оны барлық байланысты деректермен бірге толығымен жояды.",
      "delete": "Жою",
      "cancel": "Болдырмау"
    },
    "actions": {
      "enable": "Қосу",
      "disable": "Өшіру",
      "enableSuccess": "{count} ескерту(лер) сәтті қосылды",
      "disableSuccess": "{count} ескерту(лер) сәтті өшірілді"
    }
  },
  "invitation": {
    "initial": {
      "heading": "Сіз {{workspaceName}} шақырылдыңыз!",
      "login": "Кіру кілті",
      "step1": "1-қадам",
      "step1Instructions": "Gripp қосымшасын жүктеңіз",
      "step2": "2-қадам",
      "step2Instructions": "Кіру үшін осы кілтті пайдаланыңыз"
    },
    "invitePeople": {
      "copiedInvitationLink": "Шақыру сілтемесі көшірілді",
      "copyInviteLink": "Шақыру сілтемесін көшіру",
      "shareInviteLink": "Шақыру сілтемесімен бөлісу",
      "errorCopyingInvitationLink": "Шақыру URL мекенжайын көшіру кезінде қате орын алды",
      "invitePeopleForm": "Электрондық пошта арқылы адамдарды шақыру",
      "invitePeopleQR": "QR код арқылы адамдарды шақыру",
      "linkAllowsToJoinWorkplace": "Бұл сілтеме кез келген адамға жұмыс орныңызға қосылуды сұрауға мүмкіндік береді.",
      "emailPlaceholder": "Электрондық пошта",
      "inviteViaEmailLabel": "Электрондық пошта арқылы шақыру",
      "inviteSentSuccess": "Шақыру сәтті жіберілді",
      "inviteSentError": "Шақыруды жіберу кезінде қате орын алды",
      "placeholder": "Электрондық пошталар",
      "send": "Жіберу",
      "submit": "Жіберу",
      "to": "Кімге"
    },
    "pending": {
      "accepted": "Gripp аккаунтыңызға кіру үшін электрондық поштаңызға жіберілген сілтемені басыңыз.",
      "cancel": "Болдырмау",
      "join": "Қосылу",
      "joining": "Сіз {{workspaceName}} қосылудасыз",
      "title": "Профиль құру"
    },
    "qr": {
      "invitesYou": "сізді қосылуға шақырады",
      "showQr": "QR кодын көрсетіп, басқаларды шақырыңыз"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Ескертпе қосу",
      "createReport": "Есеп құру",
      "getGrippCta": "Әрекеттерді, файлдарды көру және әңгімеге қосылу үшін Gripp қосымшасын жүктеңіз!",
      "noteAdded": "Ескертпе қосылды!",
      "noteAddedDownloadGrippApp": "Ескертпелерді оңайлату үшін Gripp қосымшасын жүктеңіз!",
      "openAppStore": "App Store ашу",
      "report": "Есеп",
      "reportAddedDownloadGrippApp": "Есеп беруді жылдамдату үшін Gripp қосымшасын жүктеңіз!",
      "reported": "Мәселе хабарланды!",
      "routineCompleted": "Дайын, жаңарту расталды!",
      "routineCompletedDownloadGrippApp": "Ең жақсы тәжірибе үшін Gripp қосымшасын жүктеңіз!",
      "dropRoutineTitle": "Дайын.",
      "dropRoutineSubtitle": "Сканерлеу, есеп беру және тарихты қарауды жылдамдату үшін Gripp қосымшасында жалғастырыңыз.",
      "dropReportTitle": "Хабардар болыңыз.",
      "dropReportSubtitle": "Жауаптарды көру, ескертпелер қосу және көбірек ақпарат алу үшін Gripp қосымшасында жалғастырыңыз.",
      "dropCta": "Қосымшаны жүктеу",
      "dropCtaA11yLabel": "Gripp қосымшасын жүктеу"
    },
    "common": {
      "addPicture": "Суреттер",
      "description": "Сипаттама",
      "followUp": "Қосымша әрекет қажет пе?",
      "note": "Жоқ, тек анықтама үшін ескерту",
      "report": "Иә, қосымша әрекет қажет",
      "addLabel": "Белгі қосу",
      "labelSubtitle": "Іздеу мен сүзгілеуді жеңілдету үшін.",
      "selectLabel": "Белгі таңдау",
      "searchLabel": "Белгі іздеу",
      "createLabel": "Белгі құру",
      "emptyStateMessage": "Іздеу жолағында тікелей теріп белгі құрыңыз.",
      "labelsApplied": "Белгілер қолданылды"
    },
    "delete": {
      "confirm": "Жоюды растаңыз?",
      "button": "Issue жою",
      "warning": "Бұл әрекетті болдырмау мүмкін емес.",
      "cancel": "Бас тарту",
      "title": "Белсенділік жою"
    },
    "editModal": {
      "header": "Өңдеу",
      "save": "Сақтау",
      "reviseSubmission": "Жіберуді қайта қарау",
      "pinDescription": "Бекітілген белсенділік актив мәліметтерінде көрсетіледі"
    },
    "accessRequest": {
      "workspaceAccessRequest": "Жұмыс кеңістігіне қол жеткізу сұрауы: {{message}}",
      "requestingFullAccess": "Жұмыс кеңістігіне толық қол жеткізуді сұрау.",
      "approve": "Мақұлдау",
      "deny": "Қабылдамау",
      "approveA11y": "Қол жеткізу сұрауын мақұлдау",
      "denyA11y": "Қол жеткізу сұрауын қабылдамау"
    },
    "latestMessage": {
      "media": "[Медиа]"
    },
    "menu": {
      "delete": "Жою",
      "edit": "Өңдеу",
      "editRoutine": "Рутінді өңдеу",
      "pinToAsset": "Активке бекіту",
      "print": "Басып шығару",
      "reassign": "Қайта тағайындау",
      "reminder": "Еске салу",
      "unpin": "Бекітуді алып тастау",
      "unpinToAsset": "Активтен бекітуді алып тастау"
    },
    "new": {
      "addIt": "Есеп / Ескертпе қосу",
      "editActivity": "Әрекетті өңдеу",
      "labels": "Белгілер",
      "optionalPlaceholder": "Міндетті емес",
      "placeholder": "Сіз не көріп тұрсыз?",
      "reassign": "Қайта тағайындау",
      "reminder": "Еске салу",
      "submit": "Жіберу",
      "title": "Тақырып",
      "type": "Түрі"
    },
    "quickReminder": {
      "header": "Еске салу орнату",
      "subheader": "Бұл есепті болашақ күнге жоспарлау үшін."
    },
    "adjustCreationDate": {
      "header": "Құрылу күнін өзгерту"
    },
    "createdDate": {
      "header": "Құрылған күні"
    },
    "types": {
      "attention": "Шұғыл",
      "urgent": "Шұғыл",
      "blocker": "Күтуде",
      "pending": "Күтуде",
      "done": "Шешілді",
      "solved": "Шешілді",
      "routines": "Рутиналар",
      "note": "Ескертпе",
      "campaign": "Науқан"
    },
    "advancedSettings": "Кеңейтілген баптаулар",
    "dateFormat": "КК/АА/ЖЖЖЖ",
    "reminderFor": "Еске салу:",
    "reassign": {
      "instructions": "Келесі активтердің қайсысына қайта тағайындағыңыз келеді?",
      "placeholder": "Актив атауын іздеу",
      "saveLabel": "Сақтау",
      "title": "Қайта тағайындау"
    },
    "topBar": {
      "allReplies": "жауаптар"
    },
    "reminder": {
      "notesOptional": "Ескертпелер (міндетті емес)",
      "scheduled": "Жоспарланған еске салу"
    }
  },
  "job": "",
  "jobTitle": "Лауазым",
  "lastName": "Тегі",
  "loading": "Жүктелуде",
  "login": {
    "codeSentTo": "Кіру коды жіберілді",
    "email": "Электрондық пошта",
    "error": {
      "invalidCredentials": "Жарамсыз деректер",
      "processError": "Сіздің сұрауыңызды өңдеу кезінде қате орын алды"
    },
    "login": "Кіру",
    "password": "Құпия сөз",
    "resendCode": "Кодты қайта жіберу",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Мен қайтып келемін"
      }
    },
    "tryAnotherMethod": "Басқа әдісті көріңіз",
    "withEmail": "Электрондық поштамен жалғастыру",
    "withPassword": "Менде құпия сөз бар",
    "withPhone": "Телефонмен жалғастыру",
    "continue": "Жалғастыру",
    "skip": "Өткізіп жіберу",
    "verify": "Растау",
    "didntReceiveCode": "Код алмадыңыз ба?",
    "welcome": "Қош келдіңіз",
    "signUpToContinue": "Жалғастыру үшін тіркеліңіз",
    "orUsePrefix": "немесе",
    "toggleEmail": "электрондық пошта пайдалану",
    "togglePhone": "телефон пайдалану",
    "smsConfirmationMessage": "Біз нөміріңізді растау үшін SMS жібереміз. Бірнеше секунд алуы мүмкін.",
    "emailConfirmationMessage": "Біз электрондық поштаңызды растау үшін растау кодын жібереміз. Бірнеше секунд алуы мүмкін.",
    "verifyCodeSentTo": "Код жіберілді",
    "aboutYourself": "Өзіңіз туралы айтыңыз!",
    "existingAccount": "Gripp аккаунтыңыз бар ма?"
  },
  "logout": "Шығу",
  "errorBoundary": {
    "title": "Кешіріңіз!",
    "message": "Күтпеген қате орын алды.",
    "tryAgain": "Қайталап көріңіз"
  },
  "mentions": {
    "unknownUser": "Белгісіз пайдаланушы",
    "youAreMentioned": "Сіз аталдыңыз"
  },
  "media": {
    "validation": {
      "unsupported": "Бұл файлды жүктеу мүмкін болмады. Файл бұзылған немесе қолдау көрсетілмейтін форматта болуы мүмкін."
    }
  },
  "modalMessages": {
    "completed": "Аяқталды"
  },
  "or": "немесе",
  "onboarding": {
    "shareInfo": "Gripp-ке өзіңіз туралы көбірек айтыңыз!",
    "industrial": "Өнеркәсіп саласы",
    "source": "Gripp туралы қайдан білдіңіз?",
    "agriculture": "Ауыл шаруашылығы"
  },
  "people": {
    "menu": {
      "people": "Адамдар"
    }
  },
  "phone": "Телефон нөмірі",
  "plusMenu": {
    "add-asset": "Актив қосу",
    "invite": "Шақыру",
    "no-tag": "Тег жоқ па?",
    "note": "Ескертпе",
    "report": "Есеп",
    "scan": "Сканерлеу"
  },
  "preferences": {
    "language": {
      "languages": {
        "english": "Ағылшын",
        "spanish": "Испан",
        "russian": "Орыс",
        "kazakh": "Қазақ",
        "afrikaans": "Африкаанс",
        "portuguese": "Португал",
        "french": "Француз"
      },
      "language": "Тіл",
      "preferredLanguageTitle": "Таңдалған тіл"
    },
    "menu": {
      "title": "Баптаулар"
    },
    "settings": {
      "notifications": "Хабарландырулар",
      "permissions": "Рұқсаттар",
      "profile": "Профиль",
      "title": "Баптаулар",
      "workSpaces": "Жұмыс кеңістіктері",
      "workspace_settings": "Жұмыс кеңістігінің баптаулары"
    },
    "permissions": {
      "title": "Рұқсаттар",
      "allow": "Рұқсат беру",
      "location": {
        "label": "Геолокация қызметтері",
        "description": "Gripp активтеріңізді сканерлегенде олардың орналасуын жаңарту үшін телефоныңыздың геолокациясын пайдаланады. Кем дегенде, қолданбаны пайдалану кезінде геолокацияға рұқсат беруіңізді сұраймыз."
      },
      "camera": {
        "label": "Камераға кіру",
        "description": "Жазбалар жасау және мәселелер туралы хабарлау жиі көргеніңізді суретке түсіруді талап етеді, сондықтан камераға қол жеткізуді қосу маңызды."
      },
      "gallery": {
        "label": "Фото кітапханасына кіру",
        "description": "Камера сияқты, кейде сізде Gripp-ке жүктегіңіз келетін суреттер болады. Бізде сіз жүктеу кезінде таңдаған суреттерге ғана рұқсат болады."
      },
      "pushNotifications": {
        "label": "Push-хабарландырулар",
        "description": "Көптеген қолданбалар сияқты, жаңа дабыл, мәселе немесе есеп туралы хабарландыру алыңыз. Маңызды нәрсені жіберіп алғыңыз келмейді."
      },
      "feature": {
        "scanner": "QR кодтарын сканерлеу және жазбалар мен есептерге фотосуреттерді қосу үшін камераға қол жеткізу қажет.",
        "gallery": "Жазбалар мен есептерге галереядан суреттерді жүктеу үшін фото кітапханасына қол жеткізу қажет."
      }
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Белсенділік белгілері бойынша хабарландырулар",
      "groupNotificationsTitle": "Топ хабарландырулары",
      "issueReplies": "Хабарламалар",
      "notificationTitle": "Хабарландырулар",
      "schedule": {
        "accept": "Қабылдау",
        "cancel": "Болдырмау",
        "endTime": "Аяқталу уақыты:",
        "everyDay": "Әр күні",
        "notSet": "Орнатылмаған",
        "notificationSchedule": "Хабарландыру кестесі",
        "set": "Орнату",
        "startTime": "Басталу уақыты:",
        "weekDays": "Жұмыс күндері"
      },
      "severities": {
        "blue": "Жаңа рутіндер",
        "purple": "Жаңа ескертпелер",
        "red": "Жаңа есептер"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Профильді өңдеу"
      },
      "impersonate": {
        "impersonate": "Кіру",
        "unimpersonate": "Кіруді болдырмау"
      },
      "error": {
        "title": "Профильді жаңарту кезінде қате орын алды",
        "generic": "Профильді жаңарту кезінде қате орын алды. Қайтадан көріңізші.",
        "duplicatedPhone": "Бұл телефон нөмірі басқа аккаунтқа тіркелген."
      }
    },
    "admin": {
      "title": "Имперсонация",
      "workspace": "Жұмыс кеңістігі",
      "workspaceUsers": "Жұмыс кеңістігі пайдаланушылары"
    }
  },
  "recent_activities": "Соңғы белсенділік",
  "reminders": {
    "deleteReminder": "Еске салуды жою",
    "setNewReminder": "жаңа еске салу орнату"
  },
  "requestRoutine": {
    "apply": "Қолдану",
    "header": "Рутін",
    "instruction": "Рутін идеяңызды жіберіңіз:",
    "placeHolder": "Біз не бастауымыз керек?"
  },
  "routines": {
    "admin": {
      "create": "Сақтау",
      "instructions": "Нұсқаулар",
      "issuePrefix": "Мәселе префиксі",
      "reportOnException": "Ерекшелік бойынша есеп?",
      "routineButtonText": "Рутін батырмасы",
      "title": "Тақырып",
      "type": "Түр",
      "oneTimeOnly": "Тек бір рет",
      "autoPrompt": "Активті ашқанда автоматты түрде сұрау",
      "update": "Жаңарту",
      "addMedia": "Медиа қосу",
      "image": "Сурет",
      "link": "Сілтеме",
      "linkLabel": "Сілтеме қосу",
      "linkUrl": "Сілтеме URL",
      "linkUrlPlaceholder": "URL енгізіңіз (мысалы, https://example.com)",
      "invalidUrl": "Жарамсыз URL",
      "enableAutoPinning": "Автоматты түрде бекітуді қосу",
      "autoAddLabel": "Автоматты түрде белгі қосу"
    },
    "assign": "Рутіндерді тағайындау",
    "copyToWorkspace": {
      "save": "Көшіру",
      "title": "Жұмыс кеңістігіне көшіру",
      "workspace": "Жұмыс кеңістігі"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Ондық бөлшектерді қосу (міндетті емес)",
        "tallyCounter": "Санағыш",
        "uom": "Өлшем бірлігі",
        "counterType": "Санағыш түрі"
      },
      "user": {
        "genericCounter": {
          "change": "Өзгерту:",
          "initialValue": "Бастапқы мән:",
          "newValue": "Жаңа мән:"
        },
        "tallyCounter": {
          "add": "+ Қосу",
          "added": "Қосылды",
          "adding": "Қосу:",
          "instructions": "",
          "newValue": "Жаңа мән:",
          "oldValue": "Ескі мән:",
          "placeholder": "Сан енгізіңіз...",
          "remove": "- Жою",
          "removed": "Жойылды",
          "removing": "Жою:"
        }
      },
      "counterTypes": {
        "SIMPLE": "Қарапайым",
        "CUMULATIVE": "Жинақталатын",
        "TALLY": "Санау"
      }
    },
    "time": {
      "admin": {
        "time": "Уақыт түрі",
        "labelStartTime": "Басталу уақыты",
        "labelEndTime": "Аяқталу уақыты"
      },
      "timeTypes": {
        "START_END_TIMES": "Басталу және аяқталу уақыттары",
        "TIME_ONLY": "Тек уақыт",
        "DATE_ONLY": "Тек күн"
      },
      "message": {
        "time": "Уақыт",
        "start": "Басталу",
        "end": "Аяқталу",
        "date": "Күн"
      }
    },
    "createNew": "Рутін құру",
    "edit": {
      "header": "Рутіндер > Рутінді өңдеу",
      "title": "Рутінді өңдеу"
    },
    "editRoutines": {
      "editRoutinesButton": "Рутіндерді өңдеу",
      "label": "Белгі: ",
      "routineInWorkplace": "Жұмыс кеңістігіңізде қолжетімді барлық рутіндер",
      "title": "Өңдеу",
      "saveSuccess": "Рутіндер сәтті жаңартылды",
      "saveError": "Рутіндерді сақтау сәтсіз аяқталды",
      "routineAdded": "{{title}} рутині қосылды",
      "routineRemoved": "{{title}} рутині алып тасталды",
      "routineReordered": "Рутіндер сәтті қайта реттелді"
    },
    "exceptions": {
      "addDetails": "Мәселенің қосымша мәліметтерін немесе суреттерін қосыңыз:",
      "exceptionsNoticed": "{{count}} ерекшелік байқалды",
      "exceptionsNoticed_plural": "{{count}} ерекшеліктер байқалды",
      "reportCreated": "Есеп құрылды",
      "viewRelatedReport": "Байланысты есепті көру",
      "viewRelatedRoutine": "Байланысты рутінді көру"
    },
    "header": {
      "title": "Рутіндер",
      "view": "Көру",
      "viewAll": "Барлығын көру"
    },
    "menu": {
      "copyToWorkspace": "Жұмыс кеңістігіне көшіру",
      "delete": {
        "cancel": "Болдырмау",
        "confirm": "Иә",
        "item": "Жою",
        "title": "Сіз бұл рутінді жойғыңыз келетініне сенімдісіз бе?"
      },
      "download": "Жүктеу",
      "editRoutine": "Рутінді өңдеу",
      "export": "Деректерді экспорттау",
      "exporting": "Экспорттау..."
    },
    "message": {
      "messageTitle": "{{name}} рутін аяқтады:",
      "added": "қосылды",
      "removed": "жойылды",
      "originalValue": "Түпнұсқа мән",
      "newValue": "Жаңа мән",
      "messageTitleUpdated": "{{name}} жаңарту жасады"
    },
    "modalCancel": {
      "primary": "Сақтамай шығу.",
      "secondary": "Болдырмау",
      "title": "Артқа оралмас бұрын,"
    },
    "draftModal": {
      "continueDraft": "Жобаны жалғастыру.",
      "startNew": "Жаңа рутін бастау.",
      "cancel": "Болдырмау",
      "messageNoDraft": "Жоба сақталды",
      "messageWithoutCreator": "Жоба {{date}} сақталды",
      "messageWithCreator": "Жоба сақталды: \n{{creator}} {{date}}"
    },
    "new": {
      "chooseTypeButton": "Келесі қадам: Опцияларды таңдау",
      "header": "Рутіндер > Рутін құру",
      "title": "Рутін құру"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Опция қосу",
        "options": "Опциялар"
      }
    },
    "requestButton": "+ Рутін сұрау",
    "signature": {
      "clear": "Тазалау",
      "done": "Дайын",
      "sign": "Қол қою",
      "signature": "Қолтаңба",
      "submit": "Жіберу"
    },
    "status": {
      "admin": {
        "addStatus": "Статус қосу",
        "statuses": "Статустар",
        "openEndedResponse": "Ашық жауап",
        "otherStatus": "Басқа _______"
      }
    },
    "submit": "Жіберу",
    "resubmit": "Қайта жіберу",
    "saveDraft": "Жоба ретінде сақтау",
    "types": {
      "COUNTER": "Санағыш",
      "QUICK_CONFIRM": "Жылдам растау",
      "STATUS": "Статус",
      "WORKFLOW": "Мини-форма"
    },
    "update": "Жаңарту",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Сұрақ қосу",
          "duplicateQuestion": "Сұрақты көшіру",
          "instructions": "Нұсқаулар",
          "page": "Бет {{page}}",
          "questionType": "Сұрақ түрі"
        },
        "question": {
          "addOption": "Опция қосу",
          "exception": {
            "HasResponse": "Жауап бар",
            "MissingResponse": "Жауап жоқ",
            "Off": "Өшірілген",
            "label": "Ерекшеліктерді өңдеу:"
          },
          "instructions": "Нұсқаулар",
          "multiline": "Көпжолды",
          "options": "Опциялар",
          "question": "Сұрақ {{question}}",
          "barcodeScanner": {
            "allowMultiple": "Бірнеше жазбаға рұқсат беру",
            "includeQuantity": "Санат өрісін қосу"
          }
        },
        "routine": {
          "label": "Рутін",
          "select": "Рутін таңдау"
        }
      },
      "execution": {
        "optional": "Міндетті емес",
        "submit": "Жіберу",
        "barcodeScanner": {
          "addAnother": "Тағы бір қосу",
          "placeholder": "Штрих-кодты теріңіз немесе сканерлеңіз",
          "placeholderManual": "Штрих-кодты теріңіз",
          "quantityPlaceholder": "Сан",
          "quantityLabel": "Сан: {{quantity}}",
          "remove": "Жазбаны жою",
          "scan": "Штрих-кодты сканерлеу"
        },
        "location": {
          "placeholder": "Орынды анықтау үшін басыңыз",
          "captureLabel": "Ағымдағы орынды анықтау"
        }
      },
      "questionTypes": {
        "CHECKBOX": "Көп таңдау",
        "COUNTER": "Санағыш",
        "MEDIA": "Медиа",
        "QUICK_CONFIRM": "Жылдам растау",
        "RADIO": "Бір таңдау",
        "ROUTINE": "Рутін",
        "SIGNATURE": "Қолтаңба",
        "STATUS": "Статус",
        "TEXT": "Мәтін",
        "TIME": "Уақыт",
        "LABEL": "Белгі",
        "BARCODE_SCANNER": "Штрих-код сканері",
        "LOCATION": "Орналасу"
      }
    },
    "textEmpty": "Рутіндер жоқ",
    "addToGroups": "Топтарға қосу",
    "addToGroupsDescription": "{{count}} таңдалған рутіндерді топтарға тағайындау",
    "list": {
      "name": "Атауы",
      "type": "Түр",
      "groups": "Топтар"
    }
  },
  "saveChanges": "Өзгерістерді сақтау",
  "unsavedChanges": {
    "title": "Сақталмаған өзгерістер",
    "subtitle": "Жалғастырмас бұрын прогрессіңізді сақтағыңыз келе ме?",
    "saveAndExit": "Сақтап шығу",
    "dontSave": "Сақтамау"
  },
  "signOut": "Шығу",
  "support": {
    "genericDescription": "Кейде қателер орын алады, бірақ егер сіз бұл бетті қайта көрсеңіз, бізге хабарлаңыз, сонда біз оны түзетеміз!",
    "sendEmail": "Немесе маған электрондық пошта жіберіңіз",
    "title": "Ой, біз қателестік"
  },
  "tags": {
    "assetName": "Актив атауы",
    "batches": {
      "title": "Тапсырыстар"
    },
    "status": "Статус",
    "tagCode": "Тег нөмірі",
    "title": "Тегтер",
    "updatedAt": "Жаңартылған",
    "version": "Нұсқа"
  },
  "textEmptyList": "Деректер жоқ",
  "topNav": {
    "activities": "Белсенділік",
    "add": "Қосу",
    "assetInfo": "Активті көру",
    "assets": "Активтер",
    "back": "Артқа",
    "backButton": {
      "cancel": "Өңдеуді жалғастыру",
      "confirmBack": "Сақталмаған өзгерістер бар!",
      "ok": "Сақтамай шығу"
    },
    "cancel": "Болдырмау",
    "customAlert": {
      "cancel": "Болдырмау",
      "deleteAccount": "Аккаунтыңызды жойғыңыз келетініне сенімдісіз бе?",
      "exit": "Сақтамай шығу?",
      "signOut": "Шығуға сенімдісіз бе?",
      "yes": "Иә",
      "saveProgress": "Кейінірек сақтау."
    },
    "edit": "Өңдеу",
    "editAsset": "Актив ақпараты",
    "invite": "Адамдарды шақыру",
    "moreAssetInfo": "Активтің қосымша ақпараты",
    "moreWorkspaceInfo": "Жұмыс кеңістігінің қосымша ақпараты",
    "save": "Сақтау",
    "myHistory": "Менің тарихым",
    "modify": "Өзгерту"
  },
  "translation": {
    "seeOriginal": "Түпнұсқаны көру",
    "seeTranslation": "Аударманы көру"
  },
  "versionCheck": {
    "description": "Жаңартулар қолжетімді! Кейбір мүмкіндіктер браузерді жаңартқанға дейін жұмыс істемейтін болуы мүмкін.",
    "refreshButton": "Жаңарту"
  },
  "offline": {
    "banner": {
      "title": "Сіз офлайн режимдесіз"
    }
  },
  "workspace": {
    "editTitle": "Жұмыс кеңістігі ақпараты",
    "titleSingular": "Жұмыс кеңістігі",
    "filter": {
      "searchPlaceholder": "Атауы бойынша іздеу",
      "columnButton": "Бағандар",
      "tierButton": "Жазылым",
      "columnSelection": "Бағандар",
      "tierSelection": "Жазылым",
      "typeSelection": "Түрі",
      "columns": {
        "name": "Атауы",
        "owner": "Әкімші",
        "type": "Түр",
        "subscriptionTierId": "Жазылым",
        "assetsCount": "Активтер",
        "routinesCount": "Рутіндер",
        "alerts": "Ескертпелер",
        "peopleCount": "Адамдар",
        "activitiesCount": "Белсенділіктер",
        "groupsCount": "Топтар",
        "createdAt": "Құрылған",
        "createdDate": "Құрылған күні",
        "createdTime": "Құрылған уақыты",
        "createdBy": "Құрушы",
        "lastScanned": "Соңғы сканерлеу",
        "lastScannedDate": "Соңғы сканерлеу күні",
        "lastScannedTime": "Соңғы сканерлеу уақыты",
        "updatedAt": "Соңғы жаңарту",
        "updatedDate": "Соңғы жаңарту күні",
        "updatedTime": "Соңғы жаңарту уақыты",
        "lastActivity": "Соңғы белсенділік",
        "lastActivityDate": "Соңғы белсенділік күні",
        "lastActivityTime": "Соңғы белсенділік уақыты"
      }
    },
    "types": {
      "PRODUCER": "Өндіруші",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Жіберу",
      "administratorEmail": "Әкімші электрондық поштасы",
      "administratorPhone": "Әкімші телефон нөмірі",
      "administratorFirstName": "Әкімші аты",
      "administratorLastName": "Әкімші тегі",
      "copyRoutines": "Рутіндерді көшіру",
      "title": "Жұмыс кеңістігі құру",
      "validation": {
        "admin_email_required": "Әкімші электрондық поштасы міндетті",
        "admin_first_name_required": "Әкімші аты міндетті",
        "admin_last_name_required": "Әкімші тегі міндетті",
        "name_required": "Жұмыс кеңістігі атауы міндетті",
        "valid_emil": "Әкімші электрондық поштасы жарамды электрондық пошта мекенжайы болуы керек"
      },
      "type": "Түр",
      "workspaceName": "Жұмыс кеңістігі атауы",
      "name": "Жұмыс кеңістігі атауы"
    },
    "createButton": "Жұмыс кеңістігі құру",
    "menu": {
      "editWorkspace": "Жұмыс кеңістігін өңдеу",
      "duplicateWorkspace": "Жұмыс кеңістігін көшіру"
    },
    "duplicate": {
      "title": "Жұмыс кеңістігін көшіру",
      "sourceLabel": "Көшіру көзі",
      "contentToCopy": "Көшірілетін мазмұн",
      "activities": "Белсенділіктер",
      "assets": "Активтер",
      "routines": "Тәртіптер",
      "people": "Адамдар",
      "alerts": "Ескертулер",
      "groups": "Топтар",
      "duplicateButton": "Жұмыс кеңістігін көшіру"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Жұмыс кеңістігін жою",
      "alertBody1": "Сіз жойғыңыз келетініне сенімдісіз бе",
      "alertBody2": "Ескерту: ",
      "alertBody3": "Бұл осы жұмыс кеңістігімен байланысты активтерді жоймайды ",
      "alertBody4": "жұмыс кеңістігі.",
      "delete": "Жою",
      "cancel": "Болдырмау"
    },
    "list": {
      "name": "Атауы",
      "owner": "Әкімші",
      "type": "Түр",
      "assetsCount": "Активтер",
      "routinesCount": "Рутіндер",
      "alerts": "Ескертпелер",
      "peopleCount": "Адамдар",
      "activitiesCount": "Белсенділіктер",
      "groupsCount": "Топтар",
      "createdAt": "Құрылған",
      "createdDate": "Құрылған күні",
      "createdTime": "Құрылған уақыты",
      "createdBy": "Құрушы",
      "lastScanned": "Соңғы сканерлеу",
      "lastScannedDate": "Соңғы сканерлеу күні",
      "lastScannedTime": "Соңғы сканерлеу уақыты",
      "updatedAt": "Соңғы жаңарту",
      "updatedDate": "Соңғы жаңарту күні",
      "updatedTime": "Соңғы жаңарту уақыты",
      "lastActivity": "Соңғы белсенділік",
      "lastActivityDate": "Соңғы белсенділік күні",
      "lastActivityTime": "Соңғы белсенділік уақыты"
    }
  },
  "permissions": {
    "backButton": "Артқа",
    "continueButton": "Жалғастыру",
    "enableInSettings": "Жалғастыру үшін сіз бұл рұқсатты жүйелік мәзірде қосуыңыз керек.",
    "openSetting": "Баптауларды ашу",
    "welcome": {
      "title": "Gripp-ке қош келдіңіз!",
      "description1": "Gripp-ті пайдалану үшін бізге бірнеше рұқсат қажет.",
      "description2": "Біз әрқайсысын неге қажет екенін түсіндіру үшін сізбен бірге өтеміз.",
      "description3": "Барлық баптауларды телефоныңыздың баптаулары арқылы кез келген уақытта өзгертуге болады."
    },
    "location": {
      "initial": {
        "title": "Активтеріңізді бақылау үшін орналасуыңызға қол жеткізу.",
        "description1": "Gripp активтеріңізді сканерлеген кезде олардың орналасуын жаңарту үшін телефоныңыздың орналасуын пайдаланады.",
        "description2": "Минималды деңгейде біз сізден қосымшаны пайдаланған кезде орналасуға рұқсат беруді сұраймыз."
      },
      "denied": {
        "title": "Активтеріңізді бақылау үшін орналасуыңызға қол жеткізу.",
        "description1": "Орналасу активтеріңізді бақылауға көмектеседі."
      },
      "button": "Жалғастыру"
    },
    "camera": {
      "initial": {
        "title": "Суретке түсіру, хабарлама және есеп беру үшін камераңызға қол жеткізу.",
        "description1": "Ескертпелер жасау және мәселелер туралы хабарлау көбінесе көрген нәрсеңіздің суретін түсіруді талап етеді, сондықтан камераға қол жеткізуді қосу суретке түсіру үшін маңызды!"
      },
      "denied": {
        "title": "Суретке түсіру, хабарлама және есеп беру үшін камераға қол жеткізу.",
        "description1": "Камераға қол жеткізу мәселелерді оңай түсіріп, есеп беруге мүмкіндік береді!"
      },
      "button": "Жалғастыру"
    },
    "gallery": {
      "initial": {
        "title": "Суреттерді жүктеу үшін фото галереяңызға қол жеткізу.",
        "description1": "Камераға ұқсас, кейде сізде Gripp-ке жүктегіңіз келетін суреттер бұрыннан бар.",
        "description2": "Gripp тек сіз жүктеу кезінде таңдаған суреттерге ғана қол жеткізеді."
      },
      "denied": {
        "title": "Суреттерді жүктеу үшін фото галереяға қол жеткізу.",
        "description1": "Галереяға қол жеткізу сіз таңдаған суреттерді жүктеуге мүмкіндік береді."
      },
      "button": "Жалғастыру"
    },
    "notification": {
      "initial": {
        "title": "Хабарландырулармен жаңартылып тұрыңыз.",
        "description1": "Жаңа ескерту, мәселе немесе есеп келгенде хабардар болыңыз."
      },
      "denied": {
        "title": "Жаңартылып тұру үшін хабарландырулар.",
        "description1": "Командалық ескертулер, мәселелер және есептерді алыңыз—маркетингтік хабарламалар жоқ."
      },
      "button": "Жалғастыру"
    },
    "allSet": "Барлығы дайын, Gripp-ті пайдаланайық!"
  },
  "routine": {
    "list": {
      "name": "Атауы",
      "type": "Рутін түрі",
      "groups": "Топтар",
      "routines": "Рутіндер",
      "oldRoutines": "Ескі рутіндер",
      "asset": {
        "name": "Атауы",
        "description": "Сипаттама",
        "groups": "Топтар"
      }
    },
    "filter": {
      "searchPlaceholder": "Рутін атауын іздеу",
      "columnButton": "Бағандар",
      "columnSelection": "Бағандар",
      "columns": {
        "name": "Атауы",
        "type": "Рутін түрі",
        "assetsCount": "Активтер",
        "addonsCount": "Қосымшалар",
        "allAssetsCount": "Барлық активтер",
        "submissionsCount": "Жіберілгендер",
        "groups": "Топтар",
        "groupNames": "Топ атаулары",
        "lastSubmitted": "Соңғы жіберілген",
        "updatedAt": "Соңғы өңделген",
        "createdAt": "Құрылған күні",
        "workspace": "Жұмыс кеңістігі"
      }
    },
    "rowHeader": {
      "routineSelected": "1 рутін таңдалды",
      "routinesSelected": "{{count}} рутін таңдалды"
    },
    "permittedRoles": {
      "label": "Рұқсат Етілген Рөлдер",
      "noRoles": "Қол жетімді рөлдер жоқ"
    }
  },
  "product": {
    "change": "Өзгерту",
    "list": {
      "products": "Өнімдер",
      "name": "Атауы",
      "description": "Сипаттама",
      "assetsCount": "Активтер",
      "filesCount": "Файлдар",
      "addonsCount": "Қосымшалар",
      "routines": "Рутіндер",
      "alerts": "Актив ескертпелері",
      "productAlerts": "Өнім ескертпелері",
      "createdAt": "Құрылған",
      "updatedAt": "Соңғы жаңарту"
    },
    "filter": {
      "searchPlaceholder": "Өнім атауын іздеу",
      "columnButton": "Бағандар",
      "columns": {
        "name": "Атауы",
        "description": "Сипаттама",
        "assetsCount": "Активтер",
        "filesCount": "Файлдар",
        "addonsCount": "Қосымшалар",
        "routines": "Рутіндер",
        "alerts": "Актив ескертпелері",
        "productAlerts": "Өнім ескертпелері",
        "createdAt": "Құрылған",
        "updatedAt": "Соңғы жаңарту"
      },
      "columnSelection": "Бағандар"
    },
    "create": {
      "label": "Жаңа өнім құру",
      "validation": {
        "name_required": "Өнім атауы міндетті"
      },
      "cancel": "Болдырмау",
      "create": "Құру",
      "placeholder": "мысалы, Өнім 1"
    },
    "delete": {
      "button": "Өнімді жою",
      "cancel": "Болдырмау",
      "confirm": "Иә",
      "title": "Сіз {{productName}} өнімін жойғыңыз келетініне сенімдісіз бе?"
    },
    "detail": {
      "addon_options": "Қосымша опциялары",
      "no_addon_options": "Бұл өнім үшін қосымша опциялар жоқ.",
      "add_more": "Тағы қосу",
      "description": "Сипаттама",
      "details": "Толығырақ",
      "files": {
        "placeholder": "Жүктеуге қосымша файлдар бар ма? (деректер тақтасы, oem жапсырмалары, т.б.)",
        "addFilesLinks": "Файлдар / сілтемелер қосу"
      },
      "save": "Сақтау",
      "cancel": "Болдырмау",
      "profile": "Өнім профилі",
      "assets": "Активтер",
      "routines": "Рутіндер",
      "noAvailableRoutines": "Қосуға қолжетімді рутіндер жоқ",
      "edit": "Өңдеу",
      "delete": "Жою",
      "confirmDelete": "Сіз {{fileName}} өнімін жойғыңыз келетініне сенімдісіз бе?"
    },
    "specifications": {
      "title": "Барлық сипаттамалар",
      "upload": "Деректерді жүктеу",
      "download": "Жүктеу",
      "add_more": "Тағы қосу",
      "label_placeholder": "Сипаттама атауы",
      "value_placeholder": "Мән",
      "delete_confirm": "Сіз бұл сипаттаманы жойғыңыз келетініне сенімдісіз бе?",
      "upload_coming_soon": "CSV жүктеу функциясы жақында",
      "download_coming_soon": "CSV жүктеу функциясы жақында",
      "upload_success": "Сипаттамалар сәтті жүктелді",
      "upload_error": "Сипаттамаларды жүктеу сәтсіз аяқталды. Қайта көріңіз.",
      "download_error": "Сипаттамаларды жүктеу сәтсіз аяқталды. Қайта көріңіз.",
      "download_title": "Сипаттамаларды жүктеу",
      "no_data_to_download": "Жүктеуге сипаттамалар жоқ",
      "sharing_not_available": "Файл алмасу осы құрылғыда қолжетімсіз"
    },
    "assignments": {
      "assets": "Активтер",
      "routines": "Рутіндер",
      "files": "Файлдар",
      "addons": "Қосымшалар",
      "searchPlaceholder": "Атауы бойынша іздеу",
      "assetSearchPlaceholder": "Актив атауын іздеу",
      "routineSearchPlaceholder": "Рутін атауын іздеу",
      "fileSearchPlaceholder": "Файл атауын іздеу",
      "addonSearchPlaceholder": "Қосымша атауын іздеу"
    }
  },
  "file": {
    "list": {
      "files": "Файлдар",
      "name": "Атауы",
      "products": "Өнімдер",
      "assets": "Активтер",
      "addons": "Қосымшалар",
      "categories": "Категориялар",
      "lastUpdated": "Соңғы жаңарту",
      "createdAt": "Құрылған"
    },
    "filter": {
      "searchPlaceholder": "Файл атауын іздеу",
      "columnButton": "Бағандар",
      "categories": "Категориялар",
      "searchCategories": "Категорияларды іздеу",
      "deleteCategory": "Категорияны жою",
      "deleteCategoryMessage": "Сіз \"{{categoryName}}\" категориясын жойғыңыз келетініне сенімдісіз бе? Бұл категорияны {{fileCount}} файлдан алып тастайды.",
      "columns": {
        "name": "Атауы",
        "productsCount": "Өнімдер",
        "assetsCount": "Активтер",
        "addonsCount": "Қосымшалар",
        "categories": "Категориялар",
        "updatedAt": "Соңғы жаңарту",
        "createdAt": "Құрылған"
      },
      "columnSelection": "Бағандар"
    },
    "assignments": {
      "productsSearchPlaceholder": "Өнім атауын іздеу",
      "addonsSearchPlaceholder": "Қосымша атауын іздеу"
    },
    "create": {
      "label": "Файл қосу",
      "linkLabel": "Сілтеме қосу",
      "title": "Тақырып",
      "linkUrl": "Сілтеме URL",
      "category": "Категория",
      "file": "Файл (тек бір файл)",
      "link": "Сілтеме (тек бір сілтеме)",
      "add": "Қосу",
      "addLink": "Сілтеме қосу",
      "titlePlaceholder": "Файл тақырыбын енгізіңіз",
      "linkUrlPlaceholder": "URL енгізіңіз (мысалы, https://example.com)",
      "categoryPlaceholder": "Категорияларды таңдау",
      "categorySearchPlaceholder": "Категорияларды іздеу",
      "createCategory": "Категория құру",
      "enterCategoryNamePlaceholder": "Категория атауын енгізіңіз",
      "creatingCategory": "Құрылуда...",
      "selectCategory": "Категорияларды таңдау",
      "searchCategory": "Категорияларды іздеу",
      "emptyStateMessage": "Іздеу жолағында тікелей теріп категория құрыңыз.",
      "clickToUpload": "Файлды жүктеу үшін басыңыз",
      "linkPlaceholder": "URL енгізіңіз (мысалы, https://example.com)",
      "validation": {
        "title_required": "Файл тақырыбы міндетті",
        "category_required": "Кем дегенде бір категория міндетті",
        "link_required": "Сілтеме URL міндетті",
        "link_invalid": "Жарамды URL енгізіңіз"
      },
      "uploadError": "Файлды жүктеу сәтсіз аяқталды. Қайта көріңіз.",
      "linkError": "Сілтеме құру сәтсіз аяқталды. Қайта көріңіз.",
      "placeholder": "Файл атауы"
    },
    "dropdown": {
      "createFile": "Файл құру",
      "file": "Файл",
      "link": "Сілтеме"
    },
    "tabs": {
      "products": "Өнімдер",
      "addons": "Қосымшалар"
    },
    "deleteFile": {
      "deleteFile": "Файлды жою",
      "alertBody1": "Сіз жойғыңыз келетініне сенімдісіз бе",
      "delete": "Жою",
      "cancel": "Болдырмау"
    },
    "assets": {
      "title": "Активтер",
      "name": "Атауы",
      "description": "Сипаттама",
      "lastScanned": "Соңғы сканерлеу",
      "lastAddress": "Соңғы мекенжай",
      "lastUpdated": "Соңғы жаңарту",
      "noAssets": "Активтер табылмады"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Қосымшалар",
      "name": "Атауы",
      "product": "Өнімдер",
      "asset": "Активтер",
      "media": "Файлдар",
      "routines": "Рутіндер",
      "createdAt": "Құрылған",
      "updatedAt": "Соңғы жаңарту",
      "addon": "Қосымша"
    },
    "filter": {
      "searchPlaceholder": "Қосымша атауын іздеу",
      "columnButton": "Бағандар",
      "columns": {
        "name": "Атауы",
        "product": "Өнімдер",
        "asset": "Активтер",
        "media": "Файлдар",
        "routines": "Рутіндер",
        "createdAt": "Құрылған",
        "updatedAt": "Соңғы жаңарту"
      },
      "columnSelection": "Бағандар"
    },
    "create": {
      "label": "Қосымша құру",
      "validation": {
        "name_required": "Қосымша атауы міндетті"
      },
      "cancel": "Болдырмау",
      "create": "Құру",
      "placeholder": "мысалы, Қосымша 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Өнім атауын іздеу",
      "mediaSearchPlaceholder": "Файл атауын іздеу",
      "routineSearchPlaceholder": "Рутін атауын іздеу",
      "success": "Өнімдер қосымшаға сәтті тағайындалды",
      "error": "Өнім ID-ларын көрсету керек"
    },
    "files": {
      "title": "Файлдар",
      "name": "Атауы",
      "type": "Түр",
      "extension": "Кеңейту",
      "textEmpty": "Файлдар табылмады",
      "addFilesLinks": "Файлдар / сілтемелер қосу",
      "save": "Сақтау",
      "delete": "Жою",
      "list": {
        "name": "Атауы",
        "categories": "Категориялар"
      }
    },
    "textEmpty": "Бірінші қосымшаңызды қосу үшін '+ Қосымша құру' басыңыз.",
    "edit": {
      "label": "Қосымшаны өңдеу",
      "save": "Сақтау"
    },
    "deleteAddon": "Қосымшаны жою"
  },
  "labels": {
    "confirmTextLine1": "Сіз \"{{labelName}}\" белгісін жойғыңыз келетініне сенімдісіз бе?",
    "confirmTextLine2": "Бұл белгіні {{activityCount}} бар белсенділіктен алып тастайды.",
    "cancel": "Болдырмау",
    "delete": "Жою",
    "editLabels": "Белгілерді өңдеу",
    "labels": "Белгілер",
    "yes": "Иә"
  },
  "categories": {
    "confirmTextLine1": "Сіз \"{{categoryName}}\" категориясын жойғыңыз келетініне сенімдісіз бе?",
    "confirmTextLine2": "Бұл категорияны {{fileCount}} бар файлдан алып тастайды.",
    "cancel": "Болдырмау",
    "delete": "Жою",
    "editCategories": "Категорияларды өңдеу",
    "categories": "Категориялар",
    "yes": "Иә"
  }
}
